import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { TruckIcon, ShieldCheckIcon, ArrowRightIcon } from 'lucide-react';
export function Guarantee() {
  return <Section className="border-t border-gray-100" data-id="element-53">
      <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-54">
        {/* Shipping */}
        <div className="flex flex-col items-center text-center p-6 bg-[#F6F7FB] rounded-2xl" data-id="element-55">
          <TruckIcon className="w-10 h-10 text-[#E6007A] mb-4" data-id="element-56" />
          <h3 className="text-xl font-bold text-[#111827] mb-2" data-id="element-57">
            Envío Gratis a todo el país
          </h3>
          <p className="text-[#4B5563]" data-id="element-58">
            Despachamos por OCA a tu domicilio o sucursal más cercana. Sin costo
            extra.
          </p>
        </div>

        {/* Guarantee */}
        <div className="flex flex-col items-center text-center p-6 bg-green-50 rounded-2xl border border-green-100" data-id="element-59">
          <ShieldCheckIcon className="w-10 h-10 text-[#16A34A] mb-4" data-id="element-60" />
          <h3 className="text-xl font-bold text-[#111827] mb-2" data-id="element-61">
            Garantía de Confianza
          </h3>
          <p className="text-[#4B5563] mb-4" data-id="element-62">
            Tenés{' '}
            <span className="font-bold text-[#16A34A]" data-id="element-63">
              180 días de cambio directo
            </span>{' '}
            ante cualquier falla. Comprá tranquilo.
          </p>
        </div>
      </div>

      <div className="mt-10 text-center" data-id="element-64">
        <Button className="animate-bounce-slow" icon={ArrowRightIcon} href="https://argrutinas.com/cart/42974027186385:1" data-id="element-65">
          Quiero mi Proyector Ahora
        </Button>
      </div>
    </Section>;
}